import React from 'react';
import ReactDOM from 'react-dom/client';
import { Toast } from 'antd-mobile'
import dayjs from 'dayjs'
import App from './App';
import './index.less';
import './rem/rem'

Toast.config({ duration: 1000, position: 'top' });

React.Component.prototype.$dayjs = dayjs;    //全局挂载dayjs（class组件通过this获取）
React.$dayjs = dayjs;    //全局挂载dayjs（函数式组件通过React获取）

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);